import React, {useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import Navbar from '../layout/Navbar';
import Preloader from '../layout/preloader';
import EventosListar from '../section-pages/eventos-listar';
import Footer from '../section-pages/footer';
import ScrollToTopBtn from '../layout/ScrollToTop';
import ApiEventos from '../services/eventoService';

export default function Eventos() {
  const [eventos, setEventos] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchEventos = async () => {
     try {
       const response = await ApiEventos.listar(1);
       setEventos(response.data.eventos);
     } catch (error) {
       console.error('Erro ao buscar eventos:', error);
     } finally {
       setIsLoading(false);
     }
   };
 
   useEffect(() => {
    if (typeof window !== 'undefined') {
      const loader = document.getElementById('mainpreloader');
      if (loader) {
        setTimeout(() => {
          loader.classList.add('fadeOut');
          loader.style.display = 'none';
        }, 600);
      }
    }
    fetchEventos();
   }, []);

  return (
    <>
    {/* HEAD */}
    <Helmet>
      <link rel="icon" href="./img/icon.png" />
      <title>Fetron - Federação de Taekwondô de Rondônia</title>
    </Helmet>

    {/* LOADER */}
    <div id='mainpreloader'>
      <Preloader/>
    </div>

    {/* MENU */}
    <div className="home dark-scheme">
      <header id="header-wrap">
         <Navbar />
      </header>

      <section className="no-bg">
          <div>
            <img src="../../img/background/bg-header.png" width="100%"/>
          </div>
          <div className="container z-9">
            <div className="row align-items-center">
              <div className="col-lg-12">
                <center>
                  <h3 className="titulo">EVENTOS</h3>
                </center>
              </div>        
            </div>
          </div>
        </section>

      {/* section */}
      <section className="no-top">
        <EventosListar eventos={eventos} ano={new Date().getFullYear()}/>
      </section>

      {/* footer */}
      <Footer/>


    </div>
    <ScrollToTopBtn />
    </>
  )
}
